module.exports = __webpack_public_path__ + "static/media/thumbnail.252ec11f.jpg";